import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ProgressbarModule } from 'ngx-bootstrap/progressbar';

import { AuthRoutes } from './auth.routing';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalInterceptor, MsalModule, MsalService } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MSALInstanceFactory, MSALInterceptorConfigFactory } from './utils/auth-config';
import { MicrosoftAuthService } from './services/microsoft-auth.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ModalModule,
    ProgressbarModule,
    TooltipModule,
    BsDropdownModule,
    RouterModule.forChild(AuthRoutes),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (msalService: MsalService) => () => msalService.initialize(),
      deps: [MsalService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    MsalService,
    MicrosoftAuthService,
    MsalBroadcastService,
  ]
})
export class AuthModule {}
